import { Modal } from 'antd';
import { FC } from 'react';
import styles from './index.module.scss';
import './index.scss';
import { SideDrawerProps } from './types';
import { BackArrow } from 'utils/svgs';

const PopUpWrapper: FC<SideDrawerProps> = (props) => {
	const { isPoppedUp, title, children, closeDrawerByAnimation } = props

	const handleCancel = () => {
		closeDrawerByAnimation()
	};

	return (
		<>
			<Modal 
				open={isPoppedUp} 
				width="100vw"
				style={{ top: 0, left: 0, margin: 0, right: 0 }}
				centered={false}
				closable={false}
				footer={false}
				className='popUpWrapper'
			>
				<div className={styles['container']}>
					<div>
						<header className={styles['popUpWrapperHeader']}>
							<button
								className={`${styles['popUpWrapperBtn']}`}
								onClick={handleCancel}
							>
								<BackArrow />
								<p>BACK</p>
							</button>
							<h1>
								{title}
							</h1>

							<div></div>
						</header>

						{children}
					</div>
				</div>
				
			</Modal>
		</>
	);
};

export default PopUpWrapper;
